import { computed, ref } from 'vue';
import type { TrainingType } from '@/entities/Training';
import { useOnboardingForm } from './useOnboardingForm';
import { useRoleChangeForm } from './useRoleChangeForm';
import { useSgqPunctualForm } from './useSgqPunctualForm';
import { useOpenTrainingForm } from './useOpenTrainingForm';

export function useCreateTraining() {
  const selectedType = ref<TrainingType | null>(null);
  const onboarding = useOnboardingForm();
  const roleChange = useRoleChangeForm();
  const sgqPunctual = useSgqPunctualForm();
  const openTraining = useOpenTrainingForm();

  const canSave = computed(() => {
    if (selectedType.value === 'ONBOARDING') return onboarding.canSave.value;
    if (selectedType.value === 'ROLE_CHANGE') return roleChange.canSave.value;
    if (selectedType.value === 'SGQ_DOCUMENT_FOCAL') return sgqPunctual.canSave.value;
    if (selectedType.value === 'OPEN_TRAINING') return openTraining.canSave.value;
    return false;
  });

  const saving = computed(() => {
    if (selectedType.value === 'ONBOARDING') return onboarding.saving.value;
    if (selectedType.value === 'ROLE_CHANGE') return roleChange.saving.value;
    if (selectedType.value === 'SGQ_DOCUMENT_FOCAL') return sgqPunctual.saving.value;
    if (selectedType.value === 'OPEN_TRAINING') return openTraining.saving.value;
    return false;
  });

  async function save(): Promise<void> {
    if (selectedType.value === 'ONBOARDING') {
      await onboarding.submit();
    } else if (selectedType.value === 'ROLE_CHANGE') {
      await roleChange.submit();
    } else if (selectedType.value === 'SGQ_DOCUMENT_FOCAL') {
      await sgqPunctual.submit();
    } else if (selectedType.value === 'OPEN_TRAINING') {
      await openTraining.submit();
    }
  }

  return {
    selectedType,
    canSave,
    saving,
    save,
    onboarding,
    roleChange,
    sgqPunctual,
    openTraining,
  };
}
